import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';


// Thunks for making async requests
export const addUser = createAsyncThunk(
  'userRegister/addUser',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/user/create', formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateUser = createAsyncThunk(
  'userRegister/updateUser',
  async (formData, { rejectWithValue }) => {
    try {

      const response = await axiosInstance.post('/user/update', formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const initialState = {
  userData: [],
  status: 'idle',
  error: null
};

// Slice definition
const userRegister = createSlice({
  name: 'userRegister',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(addUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userData = action.payload;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload ? action.payload.message : action.error.message;
      })

      .addCase(updateUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.updatedData = action.payload;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload ? action.payload.message : action.error.message;
      });

  }
});

export default userRegister.reducer;
